/** Wire times are Unix seconds (P1-mobile.md); values above 1e12 are read as ms. Returns ms or null. */
export function wireTimeMs(v: unknown): number | null {
  if (typeof v !== "number" || !Number.isFinite(v) || v <= 0) return null;
  return v < 1e12 ? v * 1000 : v;
}

/** ISO string for a wire time, or null. */
export const wireIso = (v: unknown): string | null => {
  const ms = wireTimeMs(v);
  return ms === null ? null : new Date(ms).toISOString();
};
